export const warnMe = () => ({
  event: 'analytics-event',
  event_parameters: {
    event_name: 'avise_me',
  },
});
